<template>
    <div class="flex items-center justify-center gap-3">
        <!-- First & Prev -->
        <button class="px-2 text-gray-400" :disabled="currentPage === 1" @click="clickFirst">
            <!-- << button -->
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M11.8046 3.52876C12.0649 3.78911 12.0649 4.21122 11.8046 4.47157L8.27598 8.00016L11.8046 11.5288C12.0649 11.7891 12.0649 12.2112 11.8046 12.4716C11.5442 12.7319 11.1221 12.7319 10.8618 12.4716L6.86177 8.47157C6.60142 8.21122 6.60142 7.78911 6.86177 7.52876L10.8618 3.52876C11.1221 3.26841 11.5442 3.26841 11.8046 3.52876ZM7.80457 3.52876C8.06492 3.78911 8.06492 4.21122 7.80457 4.47157L4.27598 8.00016L7.80457 11.5288C8.06492 11.7891 8.06492 12.2112 7.80457 12.4716C7.54423 12.7319 7.12211 12.7319 6.86177 12.4716L2.86177 8.47157C2.73674 8.34654 2.6665 8.17697 2.6665 8.00016C2.6665 7.82335 2.73674 7.65378 2.86177 7.52876L6.86177 3.52876C7.12212 3.26841 7.54423 3.26841 7.80457 3.52876Z"
                    fill="#D1D3D8"
                />
            </svg>
        </button>
        <button class="px-2 text-gray-400" :disabled="currentPage === 1" @click="clickPrevOne">
            <!-- < button -->
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M9.80474 3.52876C10.0651 3.78911 10.0651 4.21122 9.80474 4.47157L6.27614 8.00016L9.80474 11.5288C10.0651 11.7891 10.0651 12.2112 9.80474 12.4716C9.54439 12.7319 9.12228 12.7319 8.86193 12.4716L4.86193 8.47157C4.60158 8.21122 4.60158 7.78911 4.86193 7.52876L8.86193 3.52876C9.12228 3.26841 9.54439 3.26841 9.80474 3.52876Z"
                    fill="#D1D3D8"
                />
            </svg>
        </button>

        <!-- Page Numbers -->
        <template v-if="startPage > 1">
            <button class="px-3" @click="clickPage(1)">1</button>
            <span class="px-1 font-inter-body-2">...</span>
        </template>

        <button
            v-for="page in pagesRange"
            :key="page"
            class="px-0.5 w-7 h-7 rounded"
            :class="{
                'font-inter-body-2 bg-background-basic-3': page === currentPage,
                'font-inter-body-3': page !== currentPage,
            }"
            @click="clickPage(page)"
        >
            {{ page }}
        </button>

        <template v-if="endPage < totalPage">
            <span class="px-1">...</span>
            <button class="px-3" @click="clickPage(totalPage)">{{ totalPage }}</button>
        </template>

        <!-- Next & Last -->
        <button
            class="px-2 text-gray-400"
            :disabled="currentPage === totalPage"
            @click="clickNextOne"
        >
            <!-- > button -->
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M6.19526 12.4712C5.93491 12.2109 5.93491 11.7888 6.19526 11.5284L9.72386 7.99984L6.19526 4.47124C5.93491 4.21089 5.93491 3.78878 6.19526 3.52843C6.45561 3.26808 6.87772 3.26808 7.13807 3.52843L11.1381 7.52843C11.3984 7.78878 11.3984 8.21089 11.1381 8.47124L7.13807 12.4712C6.87772 12.7316 6.45561 12.7316 6.19526 12.4712Z"
                    fill="#D1D3D8"
                />
            </svg>
        </button>
        <button
            class="px-2 text-gray-400"
            :disabled="currentPage === totalPage"
            @click="clickLast"
        >
            <!-- >> button -->
            <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M8.19526 3.52876C8.45561 3.26841 8.87772 3.26841 9.13807 3.52876L13.1381 7.52876C13.3984 7.78911 13.3984 8.21122 13.1381 8.47157L9.13807 12.4716C8.87772 12.7319 8.45561 12.7319 8.19526 12.4716C7.93491 12.2112 7.93491 11.7891 8.19526 11.5288L11.7239 8.00016L8.19526 4.47157C7.93491 4.21122 7.93491 3.78911 8.19526 3.52876ZM4.19526 3.52876C4.45561 3.26841 4.87772 3.26841 5.13807 3.52876L9.13807 7.52876C9.2631 7.65378 9.33333 7.82335 9.33333 8.00016C9.33333 8.17697 9.2631 8.34654 9.13807 8.47157L5.13807 12.4716C4.87772 12.7319 4.45561 12.7319 4.19526 12.4716C3.93491 12.2112 3.93491 11.7891 4.19526 11.5288L7.72386 8.00016L4.19526 4.47157C3.93491 4.21122 3.93491 3.78911 4.19526 3.52876Z"
                    fill="#D1D3D8"
                />
            </svg>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        modelValue: {
            type: Number,
            default: 1,
        },
        totalContent: {
            type: Number,
            default: 0,
        },
        contentsPerPage: {
            type: Number,
            default: 10,
        },
        // 한번에 보이는 페이지 수
        // 예: pageSize가 5이면, 1~5, 6~10, 11~15 등으로 페이지를 나눔
        pageSize: {
            type: Number,
            default: 5,
        },
    },
    emits: ['clickPage', 'update:modelValue'],
    computed: {
        totalPage() {
            return Math.ceil(this.totalContent / this.contentsPerPage);
        },
        pagesRange() {
            return Array.from(
                { length: this.endPage - this.startPage + 1 },
                (_, i) => this.startPage + i
            );
        },
        endPage() {
            const end = Math.ceil(this.currentPage / this.pageSize) * this.pageSize;
            return Math.min(end, this.totalPage);
        },
        startPage() {
            if (this.endPage === this.totalPage && this.endPage % this.pageSize !== 0) {
                return this.endPage - ((this.endPage % this.pageSize) - 1);
            }
            return Math.max(this.endPage - (this.pageSize - 1), 1);
        },
        currentPage: {
            get() {
                if (!this.modelValue) this.$emit('update:modelValue', 1);
                return this.modelValue;
            },
            set(value) {
                this.$emit('update:modelValue', value);
            },
        },
    },
    methods: {
        clickPage(page) {
            this.currentPage = page;
            const offset = (page - 1) * this.contentsPerPage;
            this.$emit('clickPage', offset);
        },
        clickFirst() {
            this.clickPage(1);
        },
        clickLast() {
            this.clickPage(this.totalPage);
        },
        clickPrevOne() {
            if (this.currentPage > 1) {
                this.clickPage(this.currentPage - 1);
            }
        },
        clickNextOne() {
            if (this.currentPage < this.totalPage) {
                this.clickPage(this.currentPage + 1);
            }
        },
    },
};
</script>
